import { useDocumentTitle } from "@/i18n";
import { SignUpPageView } from "./_components";

export default function SignUpPage() {
  useDocumentTitle("signUp.page");
  return <SignUpPageView />;
}
